import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title", "aria-label"]

import { ref, computed } from 'vue';
import { likeItem, unlikeItem } from '@/js/lib/api/item';
import { useItemStore } from '@/js/lib/store/item';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import HeaderHeartFill from '~icons/icon/header-heart-fill';


export default /*@__PURE__*/_defineComponent({
  __name: 'likeButtonSmall',
  props: {
    itemId: {}
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const itemStore = useItemStore();
const isLoading = ref(false);
const isLiked = computed(() => itemStore.likedItemIds.includes(props.itemId));
const title = computed(() => (isLiked.value ? 'お気に入りから外す' : 'お気に入りに追加'));
const like = async () => {
  itemStore.addLikedItemId(props.itemId);
  await likeItem({ itemId: props.itemId }).catch(() => {
    itemStore.removeLikedItemId(props.itemId);
  });

  window.dataLayer?.push({
    event: 'like',
    event_category: 'kpi',
    event_label: 'item',
  });
};
const unlike = async () => {
  itemStore.removeLikedItemId(props.itemId);
  await unlikeItem({ itemId: props.itemId }).catch(() => {
    itemStore.addLikedItemId(props.itemId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isLiked.value ? unlike() : like());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: like,
          text: 'ログインしています',
        });
        window.location.reload();
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    title: title.value,
    "aria-label": title.value,
    class: _normalizeClass(_ctx.$style.button),
    onClick: onClick
  }, [
    _createVNode(_unref(HeaderHeartFill), {
      class: _normalizeClass([_ctx.$style.icon, isLiked.value && _ctx.$style.isLiked])
    }, null, 8, ["class"])
  ], 10, _hoisted_1))
}
}

})